import type { Subscription } from '../../types';
import { getTrialDaysRemaining as getLegacySubscriptionTrialDaysRemaining } from '../legacySubscription/getTrialDaysRemaining';
import { getTrialDaysRemaining as getModernSubscriptionTrialDaysRemaining } from '../modernSubscription/getTrialDaysRemaining';

import { isModernSubscription } from './isModernSubscription';

export function getTrialDaysRemaining(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return getModernSubscriptionTrialDaysRemaining(subscription);
  }

  return getLegacySubscriptionTrialDaysRemaining(subscription);
}
